import { createStyles } from '@mantine/core';

import GamecenterPlayerDetailAction, {
  type GamecenterPlayerDetailActionProps,
} from './GamecenterPlayerDetailAction';

const useStyles = createStyles((theme) => ({
  actions: {
    display: 'flex',
    gap: theme.other.spacing._8,
    position: 'sticky',
    bottom: 0,
    right: 0,
    background: theme.white,
    padding: theme.other.spacing._16,
    boxShadow: `0px -1px 4px 0px ${theme.colors.gray2[0]}`,
  },
}));

type GamecenterPlayerDetailActionsProps = {
  actions: GamecenterPlayerDetailActionProps[];
};

function GamecenterPlayerDetailActions({ actions = [] }: GamecenterPlayerDetailActionsProps) {
  const { classes } = useStyles();

  const isHidden = actions.every((action) => action?.isHidden);

  if (isHidden) return null;

  return (
    <div className={classes.actions}>
      {actions.map((action) => (
        <GamecenterPlayerDetailAction key={action.label} {...action} />
      ))}
    </div>
  );
}

export default GamecenterPlayerDetailActions;
